import * as ActionTypes from '../ActionTypes';
const User = (state = null, action) => {
  switch (action.type) {
    case ActionTypes.SET_USER:
      console.log(action.payload);
      return { ...state, user: action.payload };

    case ActionTypes.REMOVE_USER:
      state = null;
      return { ...state, user: null };
    default:
      return state;
  }
};

export default User;
